import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { LogOut, Activity, Heart } from "lucide-react";
import NinjaBadge from "@/components/NinjaBadge";

export default function Navbar() {
  const { user, rank, logout } = useAuth();
  const nav = useNavigate();

  const doLogout = async () => {
    await logout();
    nav("/");
  };

  const currentLevel = Math.max(
    1,
    user?.completed_levels?.length ? Math.max(...user.completed_levels) : 1
  );

  return (
    <header
      className="sticky top-0 z-40 backdrop-blur-xl bg-black/60 border-b border-white/10"
      data-testid="app-navbar"
    >
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="brand-link">
          <div className="w-8 h-8 rounded-md bg-green-500/10 border border-green-500/30 flex items-center justify-center">
            <Activity className="w-4 h-4 text-green-400" />
          </div>
          <div className="font-display text-lg font-semibold tracking-tight">
            EKG<span className="text-green-400">·</span>Ninja
          </div>
        </Link>
        <nav className="flex items-center gap-3">
          {user ? (
            <>
              <Link
                to="/dashboard"
                className="text-sm text-slate-300 hover:text-white transition-colors"
                data-testid="nav-dashboard"
              >
                Dojo
              </Link>
              <Link
                to="/profile"
                className="text-sm text-slate-300 hover:text-white transition-colors"
                data-testid="nav-profile"
              >
                Profile
              </Link>
              <Link
                to="/support"
                className="text-sm text-slate-300 hover:text-red-400 transition-colors flex items-center gap-1"
                data-testid="nav-support"
              >
                <Heart className="w-3.5 h-3.5" /> Tip
              </Link>
              <div className="hidden md:flex items-center gap-2 px-3 py-1 rounded-full border border-green-500/30 bg-green-500/5">
                <span className="text-xs uppercase tracking-widest text-green-400">
                  Rank
                </span>
                <span className="text-xs font-medium text-white" data-testid="navbar-rank">
                  {rank || "Student Ninja"}
                </span>
              </div>
              <Button
                onClick={doLogout}
                variant="ghost"
                size="sm"
                className="text-slate-300 hover:text-white hover:bg-white/5"
                data-testid="logout-btn"
              >
                <LogOut className="w-4 h-4" />
              </Button>
            </>
          ) : (
            <>
              <Link
                to="/login"
                className="text-sm text-slate-300 hover:text-white transition-colors"
                data-testid="nav-login"
              >
                Log in
              </Link>
              <Link to="/register" data-testid="nav-register">
                <Button
                  size="sm"
                  className="rounded-full bg-green-500 hover:bg-green-400 text-black font-medium"
                >
                  Start Training
                </Button>
              </Link>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}
